import { Step as ModelStep, Payer } from "@redotech/redo-model/return-flow";
import { submitWarrantyFromModel } from "@redotech/redo-model/return-flow-step-from-model";
import {
  isSubmitWarrantyStepValid,
  SubmitWarrantyState,
} from "@redotech/redo-model/return-flow-step-valid";
import {
  ReturnOptionMethod,
  StoreCreditType,
} from "@redotech/redo-model/return-flow/return-option";
import { BlockLayout } from "@redotech/redo-web/flowchart";
import RefreshIcon from "@redotech/redo-web/icon-old/refresh.svg";
import * as React from "react";
import { StepType, StepTypeDetailsProps } from "../step";
import { getModelReturnOptionMethod } from "./return";
import { returnOptionLabels } from "./submit-claim";

export const SUBMIT_WARRANTY = (
  Details: React.ComponentType<StepTypeDetailsProps<SubmitWarrantyState>>,
): StepType<SubmitWarrantyState, ModelStep.SubmitWarranty> => ({
  Details: (props: StepTypeDetailsProps<SubmitWarrantyState>) =>
    React.createElement(Details, props),
  customTitle(state) {
    return state.customTitle;
  },
  title: "Submit Warranty",
  valid(state) {
    return isSubmitWarrantyStepValid(state).valid;
  },
  Icon: RefreshIcon,
  description(state) {
    return returnOptionLabels(state.option.method) || "";
  },
  downstream() {
    return [];
  },
  maxDownstream() {
    return 0;
  },
  empty: {
    option: {
      method: ReturnOptionMethod.EXCHANGE,
      creditType: StoreCreditType.GIFT_CARD,
      requireSendBack: true,
      labelPayer: Payer.MERCHANT,
      adjustmentFlat: "0",
      adjustmentPercent: "0",
      manual_label: false,
    },
  },
  layout() {
    return BlockLayout.FULL;
  },
  stepDeleted(state) {
    return state;
  },
  toModel(state) {
    return {
      customTitle: state.customTitle,
      type: ModelStep.SUBMIT_WARRANTY,
      option: {
        method: getModelReturnOptionMethod(
          state.option.method,
          state.option.creditType,
        ),
        adjustment: {
          flat: parseFloat(state.option.adjustmentFlat ?? "0"),
          proportion:
            parseFloat(state.option.adjustmentPercent ?? "0") / 100 + 1,
        },
        requireSendBack: state.option.requireSendBack,
        labelPayer: state.option.labelPayer,
        manual_label: state.option.manual_label,
        discountTitle:
          state.option.method === ReturnOptionMethod.EXCHANGE
            ? state.option.discountTitle || undefined
            : undefined,
        // Only meaningful for same-item exchange — drop the value when
        // the merchant switches the method so a stale toggle doesn't
        // silently apply if they switch back to refund/store-credit.
        chargeCustomerForNewOrderShipping:
          state.option.method === ReturnOptionMethod.EXCHANGE
            ? state.option.chargeCustomerForNewOrderShipping
            : undefined,
      },
    };
  },
  fromModel(model) {
    return submitWarrantyFromModel(model);
  },
});

export {
  type SubmitWarrantyOption,
  type SubmitWarrantyState,
} from "@redotech/redo-model/return-flow-step-valid";
